"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChangePasswordDto = instanceOfChangePasswordDto;
exports.ChangePasswordDtoFromJSON = ChangePasswordDtoFromJSON;
exports.ChangePasswordDtoFromJSONTyped = ChangePasswordDtoFromJSONTyped;
exports.ChangePasswordDtoToJSON = ChangePasswordDtoToJSON;
exports.ChangePasswordDtoToJSONTyped = ChangePasswordDtoToJSONTyped;
/**
 * Check if a given object implements the ChangePasswordDto interface.
 */
function instanceOfChangePasswordDto(value) {
    if (!('newPassword' in value) || value['newPassword'] === undefined)
        return false;
    if (!('confirmNewPassword' in value) || value['confirmNewPassword'] === undefined)
        return false;
    return true;
}
function ChangePasswordDtoFromJSON(json) {
    return ChangePasswordDtoFromJSONTyped(json, false);
}
function ChangePasswordDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'newPassword': json['newPassword'],
        'confirmNewPassword': json['confirmNewPassword'],
    };
}
function ChangePasswordDtoToJSON(json) {
    return ChangePasswordDtoToJSONTyped(json, false);
}
function ChangePasswordDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'newPassword': value['newPassword'],
        'confirmNewPassword': value['confirmNewPassword'],
    };
}
